<mat-chip-list #chipList>
  <ng-container *ngIf="formArray.getRawValue() | formlySelectOptions : field | async as chips">
    <mat-chip
      [class.invalid]="formArray.at(index).invalid"
      (removed)="removeControl(index)"
      *ngFor="let chip of chips; trackBy: trackOption; let index = index"
    >
      {{ chip.label }}
      <sn-icon matChipRemove>cancel</sn-icon>
    </mat-chip>
  </ng-container>

  <input
    matInput
    tabindex="-1"
    [formControl]="inputControl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipList"
    [matChipInputAddOnBlur]="true"
    [matChipInputSeparatorKeyCodes]="to.separatorKeysCodes"
    (blur)="onBlurClear()"
    [placeholder]="formArray.length ? 'Add more...' : to.placeholder"
  />
</mat-chip-list>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
  <ng-container *ngIf="to.options | formlySelectOptions : field | async as selectOptions">
    <mat-option
      *ngFor="let item of selectOptions; trackBy: trackOption; let index = index"
      [value]="item.value"
    >
      {{ item.label }}
    </mat-option>
  </ng-container>
</mat-autocomplete>
